import './condition-group.css';

import h from 'hyperscript';
import warning from '@disy/cadenza-icons/warning.svg';

import { icon } from 'cadenza/utils/icon/icon';

import i18n from './messages.properties';

const NAME = 'd-condition-group';

export const selector = '.' + NAME;

class ConditionGroup extends HTMLElement {

  connectedCallback () {
    this.classList.add(NAME);
    // In the beginning, before the first validation, assume that the condition group is valid,
    // so that the warning icon does not flash up shortly in slow browsers (observed in IE and Edge).
    // Also we add the icon here instead of directly on the server side markup. With a lot of condition
    // groups and a slow browser it takes some time until the connectedCallback is run after the
    // html is rendered. This also leads to the icon being displayed for a short time.
    this.classList.add('valid');
    const heading = this.querySelector('.d-panel-section--heading');
    heading.append(icon(warning));
  }

  get required () {
    return this.hasAttribute('required');
  }

  set required (required) {
    this.toggleAttribute('required', required);
  }

  get singleSelection () {
    return this.hasAttribute('singleSelection');
  }

  set singleSelection (singleSelection) {
    this.toggleAttribute('singleSelection', singleSelection);
  }

  get hasHiddenConditionsWithValues () {
    return this.hasAttribute('hasHiddenConditionsWithValues');
  }

  get validity () {
    const valueMissing = (this.required && !this.hasHiddenConditionsWithValues && !this.conditions.some(cond => cond.hasValue));
    const tooLong = (this.singleSelection && this.conditions.filter(cond => cond.hasValue).length > 1);
    return {
      valueMissing,
      tooLong,
      valid: !(valueMissing || tooLong)
    };
  }

  get conditions () {
    return [ ...this.querySelectorAll('.condition') ];
  }

  reportValidity () {
    const validity = this.validity;
    const allConditionsValid = this.conditions.every(condition => condition.validity.valid);
    this.classList.toggle('valid', validity.valid && allConditionsValid);
    if (!validity.valid) {
      if (!this._validationNotification) {
        const message = this._getValidationTitleAndMessage(validity);
        this._validationNotification = h('div.invalid-message.d-alert.d-alert-small.d-alert-warning'
          , h('span', message.message));
        this.firstElementChild.insertBefore(this._validationNotification, this.querySelector('.d-condition-wrapper'));
      }
    } else if (this._validationNotification) {
      this.firstElementChild.removeChild(this._validationNotification);
      this._validationNotification = null;
    }
    return validity.valid;
  }

  _getValidationTitleAndMessage (validity) {
    if (validity.valueMissing) {
      return {
        title: '',
        message: i18n('conditionGroup.validity.valueMissing.message')
      };
    } else if (validity.tooLong) {
      return {
        title: i18n('conditionGroup.validity.tooLong.title'),
        message: i18n('conditionGroup.validity.tooLong.message')
      };
    }
  }

}

customElements.define(NAME, ConditionGroup);
